import { IError, IFetchRailOptionByDirection, RailDirection, SelectableRailOptions } from './interfaces'

export const useState = (): RailState => {
  return {
    railDirection: 'none',
    railAdults: 0,
    selectableRailOptions: {},
    selectedRailOptionId: '',
    selectedRailOption: null
  }
}

export interface RailState {
  railDirection: RailDirection
  railAdults: number
  selectableRailOptions: IFetchRailOptionByDirection | IError
  selectedRailOptionId: string
  selectedRailOption: SelectableRailOptions | null
}
